import styled from 'styled-components';

import CreateCampaign from './NavBarActions/CreateCampaign.jsx';
import EditTemplate from './NavBarActions/EditTemplate.jsx';

const Ul = styled.ul`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Li = styled.li`
  display: flex;
  align-items: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
`;

const ClientsNavBar = ({ templateList }) => {
  return (
    <div>
      <Ul>
        <Li>
          <ButtonGroup>
            <>
              <EditTemplate templateList={templateList} />
              <CreateCampaign templateList={templateList} />
            </>
          </ButtonGroup>
        </Li>
      </Ul>
    </div>
  );
};

export default ClientsNavBar;
